import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
const AdminMyWallet = () => {
  const [walletData,setWalletData]=useState("")
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [data, setData] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  
  const walletDatas = () => {
    axios
      .post(`https://app1.crazzyhub.com/api/multivendor-super-admin-wallets-detail/`,{}, {
        headers: {
            Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setWalletData(response?.data?.super_admin_wallet_data?.current_balance)
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    walletDatas();
  }, []);
  
  console.log(walletData)
  const transitionData=()=>{
    axios
      .post(`https://app1.crazzyhub.com/api/multivendor-vendor-wallets-deduction-history/`,{}, {
        headers: {
            Token: localStorage.getItem("Token"),
        },
      })
      .then((response) => {
        setData(response?.data?.vendor_wallet_deduction_history);
        console.log("transition data===>",response?.data?.vendor_wallet_deduction_history)
      })
      .catch((error) => {
        console.log("", error);
      });
  }

  useEffect(()=>{
    transitionData()
  },[])

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">Manage deduction List</p>
          </div>
          <div className="p-2 pt-5">
          {/* <div className="items-center w-48 h-20 shadow-sm shadow-red-700 bg-blue-900 text-white rounded py-2">
            <div className="text-sm px-2 text-gray-300">Current Ballance :</div>
            <div className="text-center py-3">INR : ₹ {walletData}</div>
          </div> */}
          </div>
        </div>
        <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          
          <TableContainer component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2">
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell 
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold">ID</TableCell>
                  <TableCell style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold">ORDER ID</TableCell>
                  <TableCell style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold">DEDUCTION</TableCell>
                   <TableCell style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold">DATE </TableCell>
                  
                </TableRow>
              </TableHead>
              <TableBody>                         
                {data?.map((elem) => {
                  return (
                    <TableRow>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {elem?.id}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        
                        {elem?.order_id}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {elem?.deduction_points}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {elem?.created_at.slice(0,10)}
                      </TableCell>
                    </TableRow>
                  );
                })}
                
                  
              </TableBody>
            </Table>
            {data?.length !== 0 ? (
              <TablePagination
                rowsPerPageOptions={[6]}
                count={data?.length}
                component="div"
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            ) : null}
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default AdminMyWallet;
